import * as React from "react";
import Svg, { Rect, G, Path, Defs, ClipPath } from "react-native-svg";
const SVGComponent = (props) => (
  <Svg
    width={42}
    height={42}
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Rect width={42} height={42} rx={4.2} fill={props?.bgColor ?? "#F3F5FC"} />
    <G clipPath="url(#clip0_857_6984)">
      <Path
        opacity={0.2}
        d="M24.9375 18.434V20.6718C24.9375 22.1483 22.5389 23.3665 19.4028 23.5888C20.5439 24.0211 22.0172 24.2811 23.625 24.2811C27.2491 24.2811 30.1875 22.9588 30.1875 21.328C30.1875 19.899 27.9333 18.7079 24.9375 18.434Z"
        fill={props?.color??"#2D57D9"}
      />
      <Path
        opacity={0.2}
        d="M18.375 20.3438C21.9994 20.3438 24.9375 19.0216 24.9375 17.3906C24.9375 15.7597 21.9994 14.4375 18.375 14.4375C14.7506 14.4375 11.8125 15.7597 11.8125 17.3906C11.8125 19.0216 14.7506 20.3438 18.375 20.3438Z"
        fill={props?.color??"#2D57D9"}
      />
      <Path
        d="M18.375 20.3438C21.9994 20.3438 24.9375 19.0216 24.9375 17.3906C24.9375 15.7597 21.9994 14.4375 18.375 14.4375C14.7506 14.4375 11.8125 15.7597 11.8125 17.3906C11.8125 19.0216 14.7506 20.3438 18.375 20.3438Z"
        stroke={props?.color??"#2D57D9"}
        strokeWidth={1.3125}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M11.8125 17.3906V20.6719C11.8125 22.3027 14.7509 23.625 18.375 23.625C21.9991 23.625 24.9375 22.3027 24.9375 20.6719V17.3906"
        stroke={props?.color??"#2D57D9"}
        strokeWidth={1.3125}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M15.75 20.0977V23.3789"
        stroke={props?.color??"#2D57D9"}
        strokeWidth={1.3125}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M24.9375 18.434C27.9333 18.7079 30.1875 19.899 30.1875 21.328C30.1875 22.9588 27.2491 24.2811 23.625 24.2811C22.0172 24.2811 20.5439 24.0211 19.4028 23.5888"
        stroke={props?.color??"#2D57D9"}
        strokeWidth={1.3125}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M17.0625 23.5659V24.6094C17.0625 26.2402 20.0009 27.5625 23.625 27.5625C27.2491 27.5625 30.1875 26.2402 30.1875 24.6094V21.3281"
        stroke={props?.color??"#2D57D9"}
        strokeWidth={1.3125}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M26.25 24.0352V27.3164"
        stroke={props?.color??"#2D57D9"}
        strokeWidth={1.3125}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M21 20.0977V27.3164"
        stroke={props?.color??"#2D57D9"}
        strokeWidth={1.3125}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </G>
    <Defs>
      <ClipPath id="clip0_857_6984">
        <Rect
          width={21}
          height={21}
          fill="white"
          transform="translate(10.5 10.5)"
        />
      </ClipPath>
    </Defs>
  </Svg>
);
export default SVGComponent;
